import script from "./DocumentEventModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentEventModal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentEventModal.vue?vue&type=style&index=0&id=08eb8887&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08eb8887"]])

export default __exports__